<template>
    <div class="row" v-if="paymentList != null">
        <div class="col-lg-12">
          <div class="form-box">
            <div class="form-title-wrap">
              <div class="d-flex align-items-center justify-content-between">
                <h3 class="title">Ödeme</h3>
              </div>
            </div>
            <div class="form-content pb-2">

              <h3 class="title">Ödeme Listesi</h3>
              <p class="font-size-14">{{ paymentList.length }} listeleniyor</p>

              <div class="table-form table-responsive">
                <table class="table">
                  <thead>
                  <tr>
                    <th>#</th>
                    <th>Rezervasyon</th>
                    <th>Tutar</th>
                    <th>Tip</th>
                    <th>Status</th>
                    <th>Kur / TL</th>
                    <th>Tarih</th>
                    <th v-if="panelRights['PANEL_INVOICE_ACTIONS']">Onay Kodu</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="payment in paymentList">
                    <th scope="row">#{{payment.id}}</th>
                    <th><a :href="basePath+'/bookings/'+payment.bookingId">#{{payment.bookingId}}</a></th>
                    <th>{{ payment.amount }} €</th>
                    <th>
                      <span v-if="payment.paymentType === 'CREDIT_CARD'" class="badge py-1 px-2">Kredi Kartı</span>
                      <span v-if="payment.paymentType === 'CURRENT_ACCOUNT'" class="badge py-1 px-2">Cari Hesap</span>
                      <span v-if="payment.paymentType === 'COUPON'" class="badge py-1 px-2">Kupon</span>
                    </th>
                    <th>
                      <span v-if="payment.paymentStatus === 'SUCCESS'" class="badge badge-success py-1 px-2">Başarılı</span>
                      <span v-if="payment.paymentStatus === 'PENDING'" class="badge badge-danger py-1 px-2">Beklemede</span>
                      <span v-if="payment.paymentStatus === 'FAILED'" class="badge badge-danger py-1 px-2">Başarısız</span>
                    </th>
                    <th>
                      <div v-if="payment.exchangeRate !== 0">
                        {{ payment.exchangeRate.toFixed(2) }} / {{ payment.exchangeAmount.toFixed(2) }}
                      </div>
                    </th>
                    <th>{{ payment.createDate | ddMMyyyyHHmmSS }}</th>
                    <th v-if="panelRights['PANEL_INVOICE_ACTIONS']">{{ payment.authCode }}</th>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
</template>

<script>
import ReservationStatus from "../common/ReservationStatus";
export default {
  name: "PaymentList",
  components: {ReservationStatus},
  computed:{
    panelRights:{
      get(){
        return this.$store.getters.getPanelRightsMap;
      }
    },
    paymentList:{
      get(){
        return this.$store.getters.getPaymentList
      }
    },
    basePath:{
      get(){
        return this.$store.getters.getBasePath
      }
    }
  }
}
</script>

<style scoped>

</style>